module.exports = __webpack_public_path__ + "img/locker-room-layout.92084a5a.jpg";